import ErrorPage from "@/components/error/ErrorPage";

const ForbiddenPage: React.FC = () => {
  return (
    <ErrorPage
      statusCode={403}
      title='접근이 제한되었습니다'
      message='해당 페이지에 대한 접근 권한이 없습니다. 관리자에게 문의하시기 바랍니다.'
    />
  );
};

export default ForbiddenPage;
